<template>
    <ul class="question-list-wrapper scroll-tracker" @click="itemsClick" @scroll="scrollToEnd" ref="queslist">
        <li
            class="question-item"
            v-for="qs in transQuestions"
            :key="qs.questionId"
            :attr-id="qs.questionId"
            v-html="qs.htmlFreg"
            @mouseover="mouseOnQuestion(qs.questionId)"
            @mouseout="mouseOutQuestion"
        ></li>
        <li class="question-item" v-show="isLoading">
            {{ loadingLabel }}
        </li>
        <QuestionSimpleView
            v-if="isShowSimple"
            :content="simpleContent"
            @onview="mouseOnQuestion"
            @outview="mouseOutQuestion"
            positionTop="2px"
            positionLeft="102%"
        />
    </ul>
</template>

<script>
import QuestionSimpleView from "@/views/zhiji/components/questionEdit/answers/options/QuestionSimpleView";

export default {
    name: "QuestionList",
    props: ["questions", "keyWord", "isLoading"],
    components: {
        QuestionSimpleView
    },
    data() {
        return {
            isShowSimple: false,
            simpleContent: ""
        };
    },
    computed: {
        transQuestions() {
            return this.questions.map(qs => {
                return {
                    questionId: qs.questionId,
                    htmlFreg: (qs.sceneLevel1 + ">" + qs.sceneLevel2 + ">" + qs.question).replace(
                        this.keyWord,
                        '<span style="color: #2088f3">' + this.keyWord + "</span>"
                    )
                };
            });
        },
        loadingLabel() {
            return this.$t("zhiji.common.dataReading");
        }
    },
    methods: {
        itemsClick(event) {
            const target = event.target;
            const questionId = target.getAttribute("attr-id") || target.parentNode.getAttribute("attr-id");

            if (!questionId) {
                return;
            }

            const quesItem = this.zhiji.genItemSearchHandler("questionId")(this.questions, questionId);

            this.$emit("itemSelected", quesItem);
        },
        scrollToEnd() {
            const quesListElem = this.$refs.queslist;
            const isAtBottom = quesListElem.offsetHeight + quesListElem.scrollTop > quesListElem.scrollHeight - 2;

            if (!this.isLoading && isAtBottom) {
                this.$emit("scrollToBottom");
            }
        },
        mouseOnQuestion(questionId) {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.isShowSimple = true;
                questionId &&
                    this.zhiji
                        .requestByServiceName("queryQuesSimpleById", {
                            questionId: questionId
                        })
                        .then(resp => {
                            this.simpleContent = resp.answerText;
                        });
            }, 500);
        },
        mouseOutQuestion() {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.isShowSimple = false;
            }, 500);
        }
    }
};
</script>

<style lang="less" scoped>
.question-list-wrapper {
    width: 100%;
    overflow-y: auto;
    max-height: 280px;
    padding: 0;
    .question-item {
        position: relative;
        padding: 6px 12px;
        cursor: pointer;

        &:hover {
            background: #e4f1f9;
            color: #2ec2ff;
        }
    }
}
</style>
